import { Module } from 'src/domain';
import { useUpdateModuleInheritance } from 'src/hooks/split-levels/useUpdateModuleInheritance';

export const useMarkupUpdateInheritance = (standalone = true) => useUpdateModuleInheritance(Module.Markup, standalone);
